<app-shared-action-bar
  [displayActionSectionBar]="true"
  [saveReady]="hasUnsavedChanges && !saving"
  [undoReady]="hasUnsavedChanges && !saving"
  alternativeBackDestination="/settings/events/templates"
  (saveRequest)="saveTemplate()"
  (undoRequest)="resetTemplate()"
  (backRequest)="back()">
</app-shared-action-bar>

<div class="template-detail-page container p-4">
  <p-confirmdialog></p-confirmdialog>
  <div class="flex flex-col gap-2 md:flex-row md:items-center md:justify-between mb-4">
    <div>
      <p class="text-xs uppercase tracking-wide text-grey-700 mb-1">Events</p>
      <h1 class="text-2xl font-semibold leading-tight">{{ templateId ? 'Edit Event Template' : 'New Event Template' }}</h1>
      <p class="text-sm text-grey-800">Step through the wizard to configure your event template.</p>
    </div>
  </div>

  <div class="card shadow-sm">
    <h2 class="text-xl font-semibold mb-3">Template details</h2>
    <div class="stepper mb-4">
      <div class="step" [class.active]="currentStep === 1">1. Basics</div>
      <div class="step" [class.active]="currentStep === 2">2. Questions</div>
      <div class="step" [class.active]="currentStep === 3">3. Locations</div>
    </div>

    @if (currentStep === 1) {
      <div class="form-grid">
        <div class="form-row">
          <label for="name">Template Name</label>
          <input pInputText id="name" [(ngModel)]="editing.TemplateName" placeholder="Enter a name" (ngModelChange)="markDirty('TemplateName')" [ngClass]="{'invalid': validationErrors.TemplateName}" />
          @if (validationErrors.TemplateName) {
            <p class="error-msg">{{ validationErrors.TemplateName }}</p>
          }
        </div>
        <div class="form-row">
          <label for="mainAudit">Main {{ 'audit' | customerTerm }}</label>
          <p-select
            inputId="mainAudit"
            [options]="audits"
            optionLabel="AuditName"
            optionValue="AuditID"
            [(ngModel)]="editing.MainAuditID"
            (onChange)="onAuditChange()"
            [placeholder]="'Select the required audit' | customerText"
          [ngClass]="{'invalid': validationErrors.MainAuditID}"></p-select>
          @if (validationErrors.MainAuditID) {
            <p class="error-msg">{{ validationErrors.MainAuditID }}</p>
          }
        </div>
      </div>
    }

    @if (currentStep === 2) {
      <div class="form-grid">
        <div class="form-row">
          <label for="locationQuestion">Location Question</label>
          <p-select
            inputId="locationQuestion"
            [options]="questionOptions()"
            [(ngModel)]="editing.LocationQuestionID"
            (onChange)="markDirty('LocationQuestionID')"
            placeholder="Select a question"
            [disabled]="!selectedAudit"
          [ngClass]="{'invalid': validationErrors.LocationQuestionID}"></p-select>
          @if (validationErrors.LocationQuestionID) {
            <p class="error-msg">{{ validationErrors.LocationQuestionID }}</p>
          }
        </div>
        <div class="form-row">
          <label for="dateQuestion">Date Question</label>
          <p-select
            inputId="dateQuestion"
            [options]="questionOptions()"
            [(ngModel)]="editing.DateQuestionID"
            (onChange)="markDirty('DateQuestionID')"
            placeholder="Select a question"
            [disabled]="!selectedAudit"
          [ngClass]="{'invalid': validationErrors.DateQuestionID}"></p-select>
          @if (validationErrors.DateQuestionID) {
            <p class="error-msg">{{ validationErrors.DateQuestionID }}</p>
          }
        </div>
        <div class="form-row">
          <label for="typeQuestion">Type Question</label>
          <p-select
            inputId="typeQuestion"
            [options]="questionOptions()"
            [(ngModel)]="editing.TypeQuestionID"
            (onChange)="markDirty('TypeQuestionID')"
            placeholder="Select a question"
            [disabled]="!selectedAudit"
          [ngClass]="{'invalid': validationErrors.TypeQuestionID}"></p-select>
          @if (validationErrors.TypeQuestionID) {
            <p class="error-msg">{{ validationErrors.TypeQuestionID }}</p>
          }
        </div>
        <div class="form-row">
          <label for="summaryQuestion">Summary Question</label>
          <p-select
            inputId="summaryQuestion"
            [options]="questionOptions()"
            [(ngModel)]="editing.SummaryQuestionID"
            (onChange)="markDirty('SummaryQuestionID')"
            placeholder="Select a question"
            [disabled]="!selectedAudit"
          [ngClass]="{'invalid': validationErrors.SummaryQuestionID}"></p-select>
          @if (validationErrors.SummaryQuestionID) {
            <p class="error-msg">{{ validationErrors.SummaryQuestionID }}</p>
          }
        </div>
        <div class="form-row">
          <label for="riskQuestion">Risk Question</label>
          <p-select
            inputId="riskQuestion"
            [options]="questionOptions()"
            [(ngModel)]="editing.RiskQuestionID"
            (onChange)="markDirty('RiskQuestionID')"
            placeholder="Select a question"
            [disabled]="!selectedAudit"
          [ngClass]="{'invalid': validationErrors.RiskQuestionID}"></p-select>
          @if (validationErrors.RiskQuestionID) {
            <p class="error-msg">{{ validationErrors.RiskQuestionID }}</p>
          }
        </div>
      </div>
    }

    @if (currentStep === 3) {
      <div class="form-grid">
        <div class="form-row">
          <label>Locations</label>
          <p-multiselect
            class="w-full"
            [options]="locations"
            optionLabel="LocationName"
            optionValue="CustomerLocationID"
            [(ngModel)]="locationSelection"
            placeholder="All locations"
            display="chip"
            [showToggleAll]="false"
            (onChange)="markDirty('LocationIDs')"
            [ngClass]="{'invalid': validationErrors.LocationIDs}">
          </p-multiselect>
          @if (validationErrors.LocationIDs) {
            <p class="error-msg">{{ validationErrors.LocationIDs }}</p>
          }
        </div>
      </div>
    }

    <div class="step-actions">
      <button pButton type="button" icon="pi pi-arrow-left" class="p-button-sm p-button-text" (click)="prevStep()" [disabled]="currentStep === 1">Back</button>
      <div class="grow"></div>
      @if (currentStep < 3) {
        <button pButton type="button" icon="pi pi-arrow-right" label="Next" class="p-button-sm" (click)="nextStep()"></button>
      }
    </div>
  </div>
</div>
